import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { currencyFormatter } from "../../../../utils/formatter/formatter";

export function LowTurnoverCard({ ctx }) {

    const { averagePercent, stores, stoppedStockValue } = ctx || {};
    
    const donutOptions = {
        chart: { type: "pie", height: 160, width: 160, margin: [0, 0, 0, 0] },
        title: { text: null },
        series: [{
            innerSize: "65%",
            borderWidth: 4,
            borderColor: "#ffffff",
            data: [
                { y: averagePercent, color: "#F97316" },
                { y: 100 - averagePercent, color: "#E5E7EB" },
            ],
        }],
        tooltip: { enabled: false },
        plotOptions: {
            pie: {
                dataLabels: { enabled: false },
                states: { hover: { enabled: false } },
            },
            series: { enableMouseTracking: false },
            },
        credits: { enabled: false },
    };

    const cardStyle = { background: "#fff", borderRadius: "1.5rem", padding: "1.25rem", boxShadow: "0 2px 8px rgba(0,0,0,0.06)", display: "flex", flexDirection: "column", gap: "1rem" };
    const titleStyle = { fontWeight: "bold", fontSize: "1rem", letterSpacing: "0.05em", color: "#6B7280", margin: 0 };
    const storeLabelStyle = { fontSize: "0.75rem", width: "50px", flexShrink: 0, fontWeight: "bold" };
    const storeValueStyle = { fontSize: "0.75rem", width: "36px", textAlign: "right", fontWeight: "bold" };
    const footerStyle = {
        background: "#FFF7ED",
        border: "1px solid #FED7AA",
        borderRadius: "1rem",
        padding: "0.75rem",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    };
    const barGradient = ["#ED701D", "#F07D30", "#F38A43", "#F69756", "#F9A469"];
    const storeRowStyle = { display: "flex", alignItems: "center", gap: "0.5rem", marginBottom: "0.75rem" };
    const barTrackStyle = { flex: 1, height: "13px", background: "#E5E7EB", borderRadius: "10px", overflow: "hidden" };
    const barFillStyle = { height: "100%", borderRadius: "5px" };


  return (
    <div style={cardStyle}>
        <p style={titleStyle}>PRODUTOS COM GIRO MENOR QUE 1</p>

        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "1rem" }}>
            <div style={{ textAlign: "right" }}>
                <strong style={{
                    fontSize: "39px",
                    color: "#333333",
                    fontWeight: "700",
                    fontFamily: "'Public Sans', system-ui, sans-serif",
                    fontVariantNumeric: "tabular-nums",
                    lineHeight: 1,
                }}>
                    {averagePercent}%
                </strong>
                <p
                    style={{
                        margin: "2px 0 0 0",
                        fontSize: "0.6rem",
                        color: "#6B7280",
                        fontWeight: "700",
                        letterSpacing: "0.08em",
                        fontFamily: "'Public Sans', system-ui, sans-serif",
                    }}>
                    MÉDIA GERAL
                </p>
            </div>
            <HighchartsReact highcharts={Highcharts} options={donutOptions} />
        </div>

        <div>
        {stores.map((store, index) => (
            <div key={store.name} style={storeRowStyle}>
                <span style={storeLabelStyle}>{store.name}</span>
                <div style={barTrackStyle}>
                <div style={{ ...barFillStyle, width: `${store.percent}%`, background: barGradient[index] }} />
                </div>
                <span style={storeValueStyle}>{store.percent}%</span>
            </div>
        ))}
        </div>

        <hr style={{ border: "none", borderTop: "1px solid #F3F4F6", margin: "0", marginTop: "auto" }} />

        <div style={footerStyle}>
            <div style={{ display: "flex", alignItems: "center", gap: "0.6rem" }}>
                {/* Ícone — círculo laranja claro com seta */}
                <div style={{
                    width: 38, height: 38,
                    borderRadius: "0.5rem",
                    background: "#FED7AA",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0
                    }}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#C2410C" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="22 17 13.5 8.5 8.5 13.5 2 7" />
                        <polyline points="16 17 22 17 22 11" />
                    </svg>
                </div>
                <div>
                    <p style={{ margin: 0, fontWeight: "bold", fontSize: "0.7rem", color: "#F97316" }}>ESTOQUE PARADO</p>
                    <p style={{ margin: 0, fontSize: "0.65rem", color: "#6B7280" }}>
                        Produtos sem giro nos<br />últimos 30 dias
                    </p>
                </div>
            </div>
            <strong style={{
                color: "#ED701D",
                fontSize: "20px",
                fontWeight: "700",
                fontFamily: "'Public Sans', system-ui, sans-serif",
                fontVariantNumeric: "tabular-nums",
                whiteSpace: "nowrap",
            }}>
                {currencyFormatter.format(stoppedStockValue)}
            </strong>
        </div>
    </div>
    );
}
